import React from "react";
import { Link, Outlet } from "react-router-dom";
// import "../../../css/admin.module.css";

const UserManagement = () => {
    return (
        <div className="user-management">
          <h1>مدیریت کاربران</h1>
          <div className="user-management-actions">
            <Link to="list" className="user-management-button">
              لیست کاربران
            </Link>
            <Link to="add" className="user-management-button">
              افزودن کاربر جدید
            </Link>            
          </div>
          <div className="user-management-content">
            <Outlet />
          </div>
        </div>
      );
};

export default UserManagement;
